// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionErrorList_root__3w8q_","header":"ActionErrorList_header__27iFX","errors":"ActionErrorList_errors__18drU"};